export const formatPhoneNumber = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length === 0) {
    return '+90';
  }
  
  let cleanNumbers = numbers;
  if (numbers.startsWith('90')) {
    cleanNumbers = numbers.substring(2);
  } else if (numbers.startsWith('0')) {
    cleanNumbers = numbers.substring(1);
  }
  
  if (cleanNumbers.length <= 3) {
    return `+90 ${cleanNumbers}`;
  } else if (cleanNumbers.length <= 6) {
    return `+90 ${cleanNumbers.slice(0, 3)} ${cleanNumbers.slice(3)}`;
  } else if (cleanNumbers.length <= 8) {
    return `+90 ${cleanNumbers.slice(0, 3)} ${cleanNumbers.slice(3, 6)} ${cleanNumbers.slice(6)}`;
  } else {
    return `+90 ${cleanNumbers.slice(0, 3)} ${cleanNumbers.slice(3, 6)} ${cleanNumbers.slice(6, 8)} ${cleanNumbers.slice(8, 10)}`;
  }
};

export const validatePhoneNumber = (phone: string): boolean => {
  const numbers = phone.replace(/\D/g, '');
  return numbers.length >= 10 && numbers.length <= 12;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

